<template lang="pug">
  div
    .main
      .config-form-wrapper.row
        .config-form.col-md-12
          h2.title {{title}}
          br
          SmartForm(
            v-model="formValues"
            :formList="formList"
            :columns="columns"
            :buttonList="buttonList")
          br

</template>

<script>
import SmartForm from '@/components/SmartForm'

export default {
  name: 'change-password',
  components: {
    SmartForm
  },
  // created () {
  //   this.getData()
  // },
  data () {
    return {
      in: 'asaadsfsad',
      title: '表单模板',
      buttonList: [{
        name: 'submit',
        label: '提交',
        type: 'default',
        validate: true,
        func: ({funcProps}) => {
          console.log(funcProps.form.formValues)
        }
      }],
      formValues: {
        input: 'aaaaaaa',
        number: 12341234,
        select1: 'a',
        select2: 'aa',
        select3: 'aaa'
      },
      formList: ['input', 'number', 'password', 'select1', 'select2', 'select3'],
      columns: {
        input: {
          label: '输入框',
          form: {
            type: 'input',
            labelSize: 4,
            size: 'lg',
            placeholder: '请输入',
            prefix: {
              type: 'success',
              icon: 'user'
            },
            suffix: {
              type: 'danger',
              text: '.00'
            },
            rules: [{
              type: 'required', value: true, message: '必填'
            }, {
              type: 'minLength', value: 4, message: '最小长度为4'
            }, {
              type: 'maxLength', value: 8, message: '最大长度为8'
            }]
          }
        },
        number: {
          label: '数字输入框',
          dataType: 'number',
          form: {
            type: 'input',
            size: 'md',
            labelSize: 5,
            placeholder: '请输入数字',
            prefix: {
              type: 'success',
              text: '$'
            },
            suffix: {
              type: 'danger',
              text: '.00'
            },
            rules: [{
              type: 'required', value: true, message: '必填'
            }, {
              type: 'min', value: 4, message: '最小为4'
            }]
          }
        },
        password: {
          label: '密码输入框',
          dataType: 'password',
          form: {
            type: 'input',
            size: 'sm',
            width: 160,
            placeholder: '请输入密码',
            prefix: {
              type: 'success',
              text: '$'
            },
            rules: [{
              type: 'required', value: true, message: '必填'
            }, {
              type: 'max', value: 8, message: '最大为8'
            }]
          }
        },
        select1: {
          label: '一级选择框',
          form: {
            type: 'select',
            size: 'lg',
            width: 160,
            prefix: {
              type: 'success',
              text: '$'
            },
            chains: [{
              target: 'select2',
              type: 'optionFilter'
            }, {
              target: 'select3',
              type: 'optionClear'
            }],
            rules: [{
              type: 'required', value: true, message: '必填'
            }]
          },
          options: [{
            label: 'A',
            value: 'a'
          }, {
            label: 'B',
            value: 'b'
          }]
        },
        select2: {
          label: '二级选择框',
          form: {
            type: 'select',
            size: 'md',
            width: 160,
            suffix: {
              type: 'danger',
              text: '.00'
            },
            chains: [{
              target: 'select3',
              type: 'optionFilter'
            }],
            rules: [{
              type: 'required', value: true, message: '必填'
            }]
          },
          options: [{
            parentId: 'a',
            label: 'AA',
            value: 'aa'
          }, {
            parentId: 'a',
            label: 'AB',
            value: 'ab'
          }, {
            parentId: 'b',
            label: 'BA',
            value: 'ba'
          }, {
            parentId: 'b',
            label: 'BB',
            value: 'bb'
          }]
        },
        select3: {
          label: '三级选择框',
          form: {
            type: 'select',
            size: 'sm',
            prefix: {
              type: 'success',
              text: '$'
            },
            suffix: {
              type: 'danger',
              text: '.00'
            }
          },
          options: [{
            parentId: 'aa',
            label: 'AAA',
            value: 'aaa'
          }, {
            parentId: 'aa',
            label: 'AAB',
            value: 'aab'
          }, {
            parentId: 'ab',
            label: 'ABA',
            value: 'aba'
          }, {
            parentId: 'ab',
            label: 'ABB',
            value: 'abb'
          }, {
            parentId: 'ba',
            label: 'BAA',
            value: 'baa'
          }, {
            parentId: 'ba',
            label: 'BAB',
            value: 'bab'
          }, {
            parentId: 'bb',
            label: 'BBA',
            value: 'bba'
          }, {
            parentId: 'bb',
            label: 'BBB',
            value: 'bbb'
          }]
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.config-form-wrapper
  margin: 40px
.config-form
  margin: 0 auto
  .title
    padding-left: 140px
</style>



// WEBPACK FOOTER //
// Test.vue?3138c129